<template>
    <div class="row change-password-container">
        <div class="col-12 change-password-content-header">
            <h3 class="change-password-title">{{getDomainInfo($store.state.domain).title}}</h3>
            <div class="change-password-desc">{{getDomainInfo($store.state.domain).description}}</div>
        </div>
        <div class="col-12 ">
            <div class="row change-password-content">
                <change-password-form class="col-md-6 change-password-form"/>
                <change-password-faq class="col-md-6 change-password-faq"/>
            </div>
        </div>
    </div>
</template>

<script>
    import ChangePasswordForm from '@/components/ChangePasswordForm.vue'
    import ChangePasswordFaq from "@/components/ChangePasswordFaq.vue";

    export default {
        name: 'ChangePasswordLoginBody',
        components: {
            ChangePasswordFaq,
            ChangePasswordForm
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .change-password-container {
        padding-left: 15px;
        padding-right: 15px;
        background:#ffffff;
    }
    .change-password-title {
        font-weight: bold;
        line-height: normal;
        font-size: 38px;
        color: #000;
        padding: 30px 20px 0px 20px;
        font-family: artifaktElementBold;
    }

    .change-password-desc {
        color: #000;
        font-size: 16px;
        white-space: pre-wrap;
        padding: 15px 20px 60px 20px;
        margin-bottom:20px;
    }

    .change-password-content {
        padding: 15px 35px 60px 35px;
        margin-bottom: 20px;
    }

    .change-password-form {
        background: #FFF;
        line-height: normal;
        margin-top: -45px;
        padding: 40px;
        border: 1px solid #cccccc;
        border-radius: 4px;
    }

    .change-password-faq {
        margin-top: -75px;
        margin-bottom: 15px;
    }

    @media (min-width: 1200px) {
        .change-password-form {
          max-width: 650px;
        }
        .change-password-title {
            padding: 30px 20px 0px 150px;
        }
        .change-password-desc {
            padding: 15px 20px 60px 150px;
        }
        .change-password-content {
            padding: 15px 35px 60px 165px;
        }
        .change-password-faq{
            margin-top: -75px;
        }
    }

    @media (max-width: 576px) {
        .change-password-desc {
            font-size: 13px;
            padding: 15px 20px 30px 20px;
        }

        .change-password-title {
            font-size: 24px;
            padding: 15px 20px 0px 20px;
        }
        .change-password-content {
            padding: 15px 35px 30px 35px;
        }
        .change-password-form {
            margin-top: -25px;
            padding: 25px;
        }
        .change-password-faq{
            margin-top: 25px;
        }
    }

    @media (max-width: 400px) {
        .change-password-desc {
            font-size: 12px;
            padding: 15px 15px 30px 15px;
        }

        .change-password-title {
            font-size: 20px;
            padding: 15px 15px 0px 15px;
        }
        .change-password-content {
            padding: 15px 15px 30px 30px;
        }
        .change-password-form {
            margin-top: -25px;
            padding: 20px;
        }
        .change-password-faq{
            margin-top: 25px;
        }
    }

</style>
